// extracted by mini-css-extract-plugin
export default {"table":"users-table_table__v5SCK"};